const config = {
  templateBaseUrl: "/views/",
  useHtml5Mode: false,
  api_url: "https://api.lefresnoy.net/",
  api_media_url: "https://api.lefresnoy.net/media/",
  rest_uri_v2: "https://api.lefresnoy.net/v2/",
  rest_uri: "https://api.lefresnoy.net/v1/",
  v3_graph: "https://api.lefresnoy.net/graphql",
  media_service: "https://media.lefresnoy.net/",
  reset_password_uri: "https://api.lefresnoy.net/account/reset_password/",
  archive_rest_uri: "https://ame.lefresnoy.net/plugins/api_search/",
  archive_rest_key: "i_sMMsLMRe_zlZgu54SNsaeF793ILZY_x72WVs7irzV-FoHP2VH6QqLcYpKBRp6lBSGtXoeiZNMyZxFmADYrBA",
};

export default config;
